module.exports = __webpack_public_path__ + "img/1.fbcbccc1.png";